import React from "react";
import { Modal } from "antd";
import NotificationList from "./NotificationList";

const NotificationModal = ({
  visible = false,
  onCancel,
  groupedNotifications = {},
  title = "NOTIFICATIONS",
  onMarkAsRead,
  markAllAsRead,
}) => {
  const handleCancel = () => {
    if (markAllAsRead) {
      markAllAsRead();
    }
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <Modal
      title={title}
      open={visible}
      onCancel={handleCancel}
      footer={null}
      width={210}
      className="notification-modal"
      style={{ 
        top: 80
      }}
      bodyStyle={{
        maxHeight: "calc(100vh - 150px)",
        overflowY: "auto",
        padding: 0,
      }}
      styles={{
        header: {
          backgroundColor: 'white',
          borderBottom: '2px solid #009ad0',
          paddingTop: '2px',
          padding: '4px 14px',
          margin: 0,
          fontSize: '12px'
        },
        body: {
          marginTop: '6px'
        },
        content: {
          backgroundColor: 'white',
          padding: '12px 20px'
        },
        mask: {
          backgroundColor: 'transparent'
        }
      }}
      mask={false}
      closeIcon={
        <span 
          style={{ 
            fontSize: '12px',
            width: '12px',
            height: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#000000',
            strokeWidth: '1px'
          }}
        >
          ×
        </span>
      }
    >
      <NotificationList groupedNotifications={groupedNotifications} onMarkAsRead={onMarkAsRead} />
    </Modal>
  );
};

export default NotificationModal;